export default class Region
{
    constructor (
        id,
        name,
        grains
    ) {
        this.id = id;
        this.name = name;
        this.grains = grains;
    }
}



// WEBPACK FOOTER //
// ./apiClient/ReadModels/Region.js